var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 27,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#005C99",
    strokeWidth: 1.971,
    d: "m14.561 18.998-5.679 5.68a4.644 4.644 0 0 1-6.547 0 4.645 4.645 0 0 1 0-6.549l5.68-5.679a4.646 4.646 0 0 1 6.546 0 4.645 4.645 0 0 1 0 6.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 3.429,
    d: "m17.4 9.611-5.678 5.68a4.644 4.644 0 0 1-6.547 0 4.645 4.645 0 0 1 0-6.549l5.679-5.678c1.8-1.8 4.746-1.8 6.547 0a4.644 4.644 0 0 1 0 6.547Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#005C99",
    strokeWidth: 1.971,
    d: "m17.4 9.611-5.678 5.68a4.644 4.644 0 0 1-6.547 0 4.645 4.645 0 0 1 0-6.549l5.679-5.678c1.8-1.8 4.746-1.8 6.547 0a4.644 4.644 0 0 1 0 6.547Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 3.429,
    d: "M8.014 12.45a4.644 4.644 0 0 1 6.547 0 4.644 4.644 0 0 1 0 6.548"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#005C99",
    strokeWidth: 1.971,
    d: "m7.655 12.81.36-.358a4.64 4.64 0 0 1 6.546 0 4.641 4.641 0 0 1 0 6.545l-.459.46"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export default ForwardRef;